@if (
    asrResponseLoaded && canHaveField('latitude') && canHaveField('longitude')
) {
    <app-latitude-longitude-form
        [latitudeControl]="this.form.controls.latitude"
        [longitudeControl]="this.form.controls.longitude"
        [locationIsSavedToApplicationOrIsModification]="
            locationIsSavedToApplicationOrIsModification
        "
    >
    </app-latitude-longitude-form>
}
<section [formGroup]="form">
    @if (canHaveField('correspondingFixedLocation')) {
        <app-application-form-field
            label="Corresponding Fixed Location"
            [tooltipMessage]="messages.correspondingFixedLocation"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="Corresponding Fixed Location"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>Corresponding Fixed Location</mat-label>
                <mat-select
                    formControlName="correspondingFixedLocation"
                    #correspondingFixedLocationField
                >
                    @for (
                        option of correspondingFixedLocationOptions;
                        track option.value
                    ) {
                        <mat-option [value]="option.value">{{
                            option.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
    }

    @if (canHaveField('radius')) {
        <app-application-form-field
            label="Radius"
            [tooltipMessage]="messages.radiusTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="Radius"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>Radius</mat-label>
                <input
                    title="Radius"
                    matInput
                    type="number"
                    formControlName="radius"
                    [imask]="scheduleDStepTwoMaskConfig.radius"
                />
            </mat-form-field>
        </app-application-form-field>
    }

    @if (canHaveField('streetAddress')) {
        <app-application-form-field
            label="Street Address"
            [tooltipMessage]="messages.streetAddressTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="Street Address"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>Street Address</mat-label>
                <input
                    title="Street Address"
                    matInput
                    maxlength="80"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    formControlName="streetAddress"
                />
            </mat-form-field>
        </app-application-form-field>
    }

    @if (canHaveField('city')) {
        <app-application-form-field
            label="City"
            [tooltipMessage]="messages.cityTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="City"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>City</mat-label>
                <input
                    #cityField
                    title="City"
                    matInput
                    maxlength="20"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    formControlName="city"
                />
            </mat-form-field>
        </app-application-form-field>
    }

    @if (canHaveField('state')) {
        <app-application-form-field
            label="State"
            [tooltipMessage]="messages.stateTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="State"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>State</mat-label>
                <mat-select
                    appSelectTypeahead
                    formControlName="state"
                    #stateField
                >
                    @for (option of stateOptions; track option.value) {
                        <mat-option [value]="option.value">{{
                            option.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
    }

    @if (canHaveField('county')) {
        <app-application-form-field
            label="County"
            [tooltipMessage]="messages.countyTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="County"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>County</mat-label>
                <input
                    title="County"
                    matInput
                    maxlength="60"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    formControlName="county"
                />
            </mat-form-field>
        </app-application-form-field>
    }

    @if (canHaveField('groundElevation')) {
        <app-application-form-field
            label="Elevation of Site AMSL (Meters)"
            [tooltipMessage]="messages.groundElevationTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="Elevation of Site AMSL (Meters)"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>Elevation of Site AMSL (Meters)</mat-label>
                <input
                    title="Elevation of Site AMSL (Meters)"
                    matInput
                    [imask]="scheduleDStepTwoMaskConfig.groundElevation"
                    formControlName="groundElevation"
                />
            </mat-form-field>
        </app-application-form-field>
    }

    @if (canHaveField('heightOfSupportStructure')) {
        <app-application-form-field
            label="Overall Ht AGL Without Appurtenances (Meters)"
            [tooltipMessage]="messages.heightOfSupportStructureTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="Overall Ht AGL Without Appurtenances (Meters)"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label
                    >Overall Ht AGL Without Appurtenances (Meters)</mat-label
                >
                <input
                    title="Overall Ht AGL Without Appurtenances (Meters)"
                    matInput
                    [imask]="schedulesDAndHMaskConfig.heightOfStructure"
                    formControlName="heightOfSupportStructure"
                />
            </mat-form-field>
        </app-application-form-field>
    }

    @if (canHaveField('overallHeightOfStructure')) {
        <app-application-form-field
            label="Overall Ht AGL with Appurtenances (Meters)"
            [tooltipMessage]="messages.overallHeightOfStructureTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="Overall Ht AGL with Appurtenances (Meters)"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label
                    >Overall Ht AGL with Appurtenances (Meters)</mat-label
                >
                <input
                    title="Overall Ht AGL with Appurtenances (Meters)"
                    matInput
                    [imask]="schedulesDAndHMaskConfig.heightOfStructure"
                    formControlName="overallHeightOfStructure"
                />
            </mat-form-field>
        </app-application-form-field>
    }

    @if (canHaveField('structureTypeCode')) {
        <app-application-form-field
            label="Support Structure Type"
            [tooltipMessage]="messages.structureTypeCodeTooltip"
            [inline]="true"
            [dialogTooltip]="true"
            dialogTooltipTitle="Support Structure Type"
            [showTooltipIcon]="true"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>Support Structure Type</mat-label>
                <mat-select
                    appSelectTypeahead
                    formControlName="structureTypeCode"
                >
                    @for (option of structureTypeOptions; track option.value) {
                        <mat-option [value]="option.value">{{
                            option.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
    }

    @if (canHaveField('areaOfOperationText')) {
        <app-application-form-field
            label="Description"
            [showTooltipIcon]="false"
        >
            <mat-form-field
                appearance="outline"
                class="w-full max-w-[400px]"
                color="primary"
            >
                <mat-label>Description</mat-label>
                <textarea
                    #areaOfOperationTextField
                    title="Description"
                    matInput
                    maxlength="255"
                    formControlName="areaOfOperationText"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    class="!h-40 !resize-none"
                ></textarea>
            </mat-form-field>
        </app-application-form-field>
    }
</section>
